import { Task, TaskStatus, TaskProvider } from '../../types';

interface BarzhaClickAd {
  id: number;
  title: string;
  description?: string;
  image_url?: string;
  reward_amount?: number;
  reward_type?: string;
  status?: string;
  visibility?: boolean;
}

export class BarzhaClickAdapter {
  /**
   * Адаптирует объявления BarzhaClick в формат заданий приложения
   */
  static async adaptTasks(ads: BarzhaClickAd[]): Promise<Task[]> {
    if (!ads || ads.length === 0) {
      return [];
    }
    
    // Фильтруем объявления по видимости
    const visibleAds = ads.filter(ad => ad.visibility !== false);
    
    if (visibleAds.length === 0) {
      console.log('ℹ️ BarzhaClickAdapter - нет видимых объявлений');
      return [];
    }
    
    return visibleAds.map(ad => {
      // Определяем статус задания
      let taskStatus: TaskStatus = 'NOT_STARTED';
      if (ad.status) {
        switch (ad.status.toLowerCase()) {
          case 'completed':
          case 'done':
            taskStatus = 'DONE';
            break;
          case 'in_progress':
            taskStatus = 'IN_PROGRESS';
            break;
          case 'claimed':
            taskStatus = 'CLAIMED';
            break;
          default:
            taskStatus = 'NOT_STARTED';
        }
      }
      
      return {
        id: ad.id,
        title: ad.title,
        description: ad.description || 'Выполните задание и получите награду',
        icon: ad.image_url || '',
        rewards: {
          tickets: 1
        },
        status: taskStatus,
        provider: 'BARZHA_CLICK' as TaskProvider,
        type: 'sponsor',
        buttonText: taskStatus === 'DONE' ? 'Получить награду' : 'Перейти'
      };
    });
  }
}
